import React, { useState } from 'react';
import cogoToast from 'cogo-toast';
import { saveAs } from 'file-saver';
import ExcelJS from 'exceljs';
import ApiURL from '../../api/ApiURL';
import axios from 'axios';

const VendorPayableReportModal = ({ show, tcData, onClose }) => {

    const [locationData, setLocationData] = useState([]);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [tcId, setTCId] = useState('');
    const [locId, setLocationId] = useState('');

    //Export data to excel file with formatting
    const exportToExcel = async (data) => {
        if (!data || data.length === 0) {
            cogoToast.warn("No data found to export", { position: "bottom-center" });
            return;
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Vendor Payable Report');

        /* ================= HEADER ================= */
        worksheet.columns = [
            { header: 'Sub Booking No', key: 'SubBookingNo', width: 20 },
            { header: 'Sub Booking Type', key: 'SubBookingType', width: 18 },
            { header: 'Vendor', key: 'VendorName', width: 35 },
            { header: 'Start Date', key: 'StartDate', width: 18 },
            { header: 'End Date', key: 'EndDate', width: 18 },
            { header: 'Travel Circuit', key: 'TravelCircuitName', width: 20 },
            { header: 'Location', key: 'LocationName', width: 20 },
            { header: 'First Name', key: 'FirstName', width: 20 },
            { header: 'Last Name', key: 'LastName', width: 20 },
            { header: 'Vendor Payable', key: 'PayableAmount', width: 15 },
            { header: 'Paid To Vendor', key: 'PaidAmount', width: 15 },
            { header: 'Due To Vendor', key: 'DueAmount', width: 15 }
        ];

        /* ================= FREEZE HEADER ================= */
        worksheet.views = [{ state: 'frozen', ySplit: 1 }];

        /* ================= STYLE HEADER ================= */
        worksheet.getRow(1).eachCell(cell => {
            cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: '4472C4' }
            };
            cell.alignment = { vertical: 'middle', horizontal: 'center' };
            cell.border = {
                top: { style: 'thin' },
                bottom: { style: 'thin' },
                left: { style: 'thin' },
                right: { style: 'thin' }
            };
        });

        /* ================= DATA ================= */
        data.forEach(item => {
            worksheet.addRow(item);
        });

        /* ================= BORDER ALL CELLS ================= */
        worksheet.eachRow(row => {
            row.eachCell(cell => {
                cell.border = {
                    top: { style: 'thin' },
                    bottom: { style: 'thin' },
                    left: { style: 'thin' },
                    right: { style: 'thin' }
                };
            });
        });

        /* ================= DOWNLOAD ================= */
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        saveAs(blob, 'Vendor_Payable_Report.xlsx');
    };

    //Reset search data
    const onReset = () => {
        setLocationData([]);
        setStartDate('');
        setEndDate('');
        setTCId('');
        setLocationId('');
    }

    //Close Modal
    const onCloseModal = () => {
        onReset();
        onClose();
    }

    //onChangeTCHandler
    const onChangeTCHandler = (e) => {
        getLocationData(e.target.value);
    }

    //Fetch Location data by Travel Circuit
    const getLocationData = async (tcId) => {
        try {
            const response = await axios.get(ApiURL.GetAllLocationByTC(tcId));
            if (response.data.StatusCode === 200) {
                setTCId(tcId);
                setLocationData(response.data.DataResult);
            } else {
                cogoToast.warn("No data found", { position: "bottom-center" });
            }

        } catch {
            cogoToast.error("Request Failed!", { position: "bottom-center" });
        }
    }

    //Fetch api data
    const getReportData = async (e) => {
        e.preventDefault();

        if (!startDate || !endDate) {
            cogoToast.error("Start & End Date required!", { position: "bottom-center" });
            return;
        }
        if (tcId == 0) {
            cogoToast.error("Travel Circuit required!", { position: "bottom-center" });
            return;
        }

        try {
            const response = await axios.post(ApiURL.GetVendorPayableReportData, {
                StartDate: startDate,
                EndDate: endDate,
                TravelCircuitId: tcId,
                LocationId: locId
            });

            if (response.data.StatusCode === 200) {
                exportToExcel(response.data.DataResult);
            } else if (response.data.StatusCode === 404) {
                cogoToast.warn("No data found", { position: "bottom-center" });
            }
            else if (response.data.StatusCode === 500) {
                cogoToast.error("Request Failed!", { position: "bottom-center" });
            }

        } catch {
            cogoToast.error("Request Failed!", { position: "bottom-center" });
        }
    };

    if (!show) return null;

    return (
        <div className="modal show-modal modalWrapper">
            <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content">

                    <div className="modal-header">
                        <h3>Vendor Payable Report</h3>
                        <i className="fa-regular fa-circle-xmark text-danger" onClick={onCloseModal}></i>
                    </div>

                    <div className="modal-body">
                        <div className="row g-3">
                            <div className="col-md-3">
                                <label>Start Date <span className='text-danger'>*</span></label>
                                <input type="date" className="form-control-sm w-100"
                                    value={startDate}
                                    onChange={e => setStartDate(e.target.value)} />
                            </div>

                            <div className="col-md-3">
                                <label>End Date <span className='text-danger'>*</span></label>
                                <input type="date" className="form-control-sm w-100"
                                    value={endDate}
                                    onChange={e => setEndDate(e.target.value)} />
                            </div>

                            <div className="col-md-3">
                                <label>Travel Circuit <span className='text-danger'>*</span></label>
                                <select className="form-control-sm w-100"
                                    value={tcId}
                                    onChange={onChangeTCHandler}>
                                    <option value="">-- Select --</option>
                                    {tcData.map(tc => (
                                        <option key={tc.TravelCircuitId} value={tc.TravelCircuitId}>
                                            {tc.TravelCircuitName}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="col-md-3">
                                <label>Location</label>
                                <select className="form-control-sm w-100"
                                    value={locId}
                                    onChange={e => setLocationId(e.target.value)}>
                                    <option value="">-- Select --</option>
                                    {locationData.map(loc => (
                                        <option key={loc.LocationId} value={loc.LocationId}>
                                            {loc.LocationName}
                                        </option>
                                    ))}
                                </select>
                            </div>

                        </div>
                    </div>

                    <div className="modal-footer">
                        <button className="btn btn-outline-primary" onClick={getReportData}>
                            Download Report
                        </button>
                        <button className="btn btn-outline-secondary" onClick={onReset}>
                            Reset
                        </button>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default VendorPayableReportModal;
